import {
  initialPurchaseOrderForm,
  OrderLineForm,
  PurchaseOrder,
  PurchaseOrderForm,
  PurchaseOrderInfo,
} from '../types/PurchaseOrder';
import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

type PurchaseOrderState = {
  data: PurchaseOrder | null;
  setData: (data: PurchaseOrder | null) => void;
  formData: PurchaseOrderForm;
  setFormData: (
    data: PurchaseOrderForm | PurchaseOrderInfo | undefined,
  ) => void;
  orderLine: OrderLineForm | null;
  setOrderLine: (data: OrderLineForm) => void;
  addOrderLine: (data: OrderLineForm) => void;
  editOrderLine: (id: string, newData: OrderLineForm) => void;
  removeOrderLine: (id: string | undefined | null) => void;
  resetForm: () => void;
};

export const usePurchaseOrderStore = create<PurchaseOrderState>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  formData: initialPurchaseOrderForm,
  setFormData: (formData) => set({ formData }),
  orderLine: null,
  setOrderLine: (orderLine) => set({ orderLine }),
  addOrderLine: (data: OrderLineForm) => {
    const newData = { ...data, uuid: uuidv4() };
    set((state) => ({
      formData: {
        ...state.formData,
        orderLines: [...state.formData.orderLines, newData],
      },
    }));
  },
  editOrderLine: (uuid, newData) => {
    // Implementation of editOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        orderLines: state.formData.orderLines.map((line) =>
          line.uuid === uuid ? { ...line, ...newData } : line,
        ),
      },
    }));
  },
  removeOrderLine: (uuid) => {
    // Implementation of removeOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        orderLines: state.formData.orderLines.filter(
          (line) => line.uuid !== uuid,
        ),
      },
    }));
  },
  resetForm: () => set({ formData: initialPurchaseOrderForm }),
}));
